export default "__VITE_ASSET__CETwZTT4__"